export default "__VITE_ASSET__CcEQV4WO__"